<template>
    <v-card elevation="2" height="100%">
        <v-card-text>
            <h2 v-if="!hideTitle" class="display-1 mb-4">Time Ordered by Client</h2>
            <v-layout jusitify-space-between :row="layout == 'bar'" :column="layout != 'bar'">
                <v-flex shrink>
                    <template>
                        <v-flex>
                            <v-menu
                                ref="startDateMenu"
                                v-model="startDateMenu"
                                :close-on-content-click="false"
                                :nudge-right="40"
                                lazy
                                transition="scale-transition"
                                offset-y
                                full-width
                                min-width="290px"
                            >
                                <template slot="activator" slot-scope="{ on }">
                                    <v-text-field
                                        label="Start Date"
                                        format="dddd, MM DD YYYY"
                                        @change="(value) => (startDate = value)"
                                        :value="dateFormatted(startDate)"
                                        prepend-icon="event"
                                        readonly
                                        v-on="on"
                                    ></v-text-field>
                                </template>
                                <v-date-picker
                                    v-model="startDate"
                                    @input="startDateMenu = false"
                                    no-title
                                    scrollable
                                    :show-current="endDate"
                                >
                                </v-date-picker>
                            </v-menu>
                        </v-flex>
                    </template>
                </v-flex>
                <v-flex shrink>
                    <template>
                        <v-flex>
                            <v-menu
                                ref="endDateMenu"
                                v-model="endDateMenu"
                                :close-on-content-click="false"
                                :nudge-right="40"
                                lazy
                                transition="scale-transition"
                                offset-y
                                full-width
                                min-width="290px"
                            >
                                <template slot="activator" slot-scope="{ on }">
                                    <v-text-field
                                        label="End Date"
                                        format="dddd, MM DD YYYY"
                                        @change="(value) => (endDate = value)"
                                        :value="dateFormatted(endDate)"
                                        prepend-icon="event"
                                        readonly
                                        v-on="on"
                                    ></v-text-field>
                                </template>
                                <v-date-picker v-model="endDate" @input="endDateMenu = false" no-title scrollable :show-current="startDate">
                                </v-date-picker>
                            </v-menu>
                        </v-flex>
                    </template>
                </v-flex>
                <v-flex class="ml-2" shrink>
                    <v-select v-model="timePeriod" :items="timePeriodItems" label="Time Period"> </v-select>
                </v-flex>
                <v-spacer />
                <v-flex>
                    <v-autocomplete
                        v-model="selectedClientId"
                        :items="possibleClients"
                        label="Client Business"
                        item-value="id"
                        item-text="name"
                        :search-input.sync="clientSearcher"
                        @click="getPossibleClients"
                        :loading="loadingClients"
                    >
                    </v-autocomplete>
                </v-flex>
            </v-layout>
            <v-card-actions>
                <v-layout justify-end>
                    <v-btn @click="getRecords" :disabled="!allChoicesMade" color="primary">
                        {{ buttonText }}
                    </v-btn>
                </v-layout>
            </v-card-actions>
        </v-card-text>
    </v-card>
</template>

<script>
import { mapState } from "vuex";
import collectionsApi from "@/api/collections";

export default {
    components: {},
    computed: {
        ...mapState("userAuth", ["user"]),
    },
    created() {},
    props: {
        hideTitle: {
            default: false,
            type: Boolean,
        },
        layout: {
            default: "",
            type: String,
        },
        buttonText: {
            default: "Get Report",
            type: String,
        },
    },
    watch: {
        clientSearcher(value) {
            // this triggers when anything is entered into the clients autocomplete
            this.getPossibleClients();
        },
    },
    data: function () {
        return {
            startDateMenu: false,
            endDateMenu: false,
            startDate: "",
            endDate: "",
            selectedClientId: null,
            possibleClients: [],
            loadingClients: false,
            clientSearcher: null,
            timePeriod: "By Year",
            timePeriodItems: ["By Year", "By Month", "By Quarter"],
        };
    },
    computed: {
        allChoicesMade: function () {
            if (this.startDate && this.endDate && this.selectedClientId) {
                return true;
            } else {
                return false;
            }
        },
    },
    methods: {
        getRecords: function () {
            this.$router.push({
                name: "clientTimeOrderedReport",
                query: {
                    startDate: this.startDate,
                    endDate: this.endDate,
                    timePeriod: this.timePeriod,
                    selectedClientId: this.selectedClientId,
                },
            });
        },

        getPossibleClients: function () {
            if (this.possibleClients.length > 0) {
                // already got them
                return;
            }
            if (this.loadingClients) {
                // already started getting them
                return;
            }
            this.loadingClients = true;

            // get clients
            collectionsApi.getClientBusinesses(
                (clients) => {
                    this.possibleClients = clients;
                    this.loadingClients = false;
                },
                (error) => {
                    this.loadingClients = false;
                },
            );
        },

        dateFormatted: function (date) {
            return date ? this.$moment(date).format("dddd, MMMM D") : "";
        },
    },
};
</script>
